<template>
  <div class="sign-in-sign-up-layout">
    <div class="left-side">
      <SignInSignUpContent>
        <slot></slot>
      </SignInSignUpContent>
      <div class="copywrite">© {{ year }} EasyAgency. All rights reserved.</div>
    </div>
    <div class="right-side" />
  </div>
</template>

<script>
import SignInSignUpContent from '@components/sign-up/SignInSignUpContent.vue'

export default {
  name: 'SignInSignUpLayout',
  components: { SignInSignUpContent },
  computed: {
    year () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped lang="scss">
.sign-in-sign-up-layout {
  display: flex;
  width: 100%;
  height: 100vh;
}

.left-side {
  position: relative;
  flex-basis: 50%;
  display: flex;
  flex-direction: column;
  padding-top: 88px;
  border-radius: 0 30px 30px 0;
  background: white;
}

.right-side {
  flex-grow: 1;
  margin-left: -30px;
  background: url("/images/signin-img.webp") center;
  background-size: cover;
}

.copywrite {
  margin: 16px 0;
  color: $fontColor2;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}
</style>
